export default function(role) {
  // const role = localStorage.getItem('userRole')
  const menuItems = [

    // {
    //   title: "Analytics",
    //   // htmlBefore: '<i class="material-icons">vertical_split</i>',
    //   to: "/analysis",
    // },
    {
      title: "Soil Health Monitoring",
      to: "/",
      roles: ["user", "Admin","superAdmin"],
      // htmlBefore: '<i class="material-icons">edit</i>',
    },
    {
      title: "Soil Testing",
      to: "/soil-testing",
      roles: ["user", "Admin","superAdmin"],
      // htmlBefore: '<i class="material-icons">edit</i>',
    },
 
    {
      title: "Crop Recommendation",
      // htmlBefore: '<i class="material-icons">note_add</i>',
      to: "/crop-recommendation",
      roles: ["Admin", "superAdmin"]
    },


    {
      title: "Soil Data Analysis",
      // htmlBefore: '<i class="material-icons">note_add</i>',
      to: "/agri/soil/data/analysis",
      roles: [ "Admin", "superAdmin"]
    },
    {
      title: "Dashboard",
      // htmlBefore: '<i class="material-icons">note_add</i>',
      to: "/feedback/summary",
      roles: ["Expert", "Admin","superAdmin"]
    },
    {
      title: "Fertilizer Recommendation",
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/fertilizer-recommendation",
      roles: ["user","Expert", "Admin", "superAdmin"]
    },
    {
      title: "Expert Modules",
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/expert-modules",
      roles: ["user"]
    },
    {
      title: "Soil Type Detector",
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/soil/type/detector",
      roles: [ "Admin", "superAdmin"]
    },

    // {
    //   title: "Weather Prediction",
    //   // htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/weather-prediction",
    //   roles: [ "Admin", "superAdmin"]
    // }, 
    {
      title: "Seed Quality Detection",
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/seeds/detection",
      roles: [ "Admin", "superAdmin"]
    },
    {
      title: "Soyabean Plant Heath Detection",
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/disease-detection",
      roles: [ "Admin", "superAdmin"]

    },
    {
      title: "Yield Prediction",
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/yield-prediction",
      roles: [ "Admin", "superAdmin"]

    },
    // {
    //   title: "Visualisation",
    //   // htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/visualisation",
    // },
    {
      title: "SoyaBean Statistics",
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/soya",
      roles: [ "Admin", "superAdmin"]

    },
    {
      title: "Management Practices",
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/management_practices",
      roles: [ "Admin", "superAdmin"]

    },
    // {
    //   title: "Reports",
    //   // htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/reports",
    //   roles: [ "Admin", "superAdmin"]

    // },
    // {
    //   title: "Soil Test Analyzer",
    //   // htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/soil/test/analyzer",
    // },
    {
      title: "Nutrient Calculator",
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/soil/nutrient/calculator",
      roles: [ "Admin", "superAdmin"]
    },
    // {
    //   title: "User Management",
    //   // htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/user_management",
    //   roles: ["Admin", "superAdmin"]
    // },



    // {
    //   title: "Tables",
    //   htmlBefore: '<i class="material-icons">table_chart</i>',
    //   to: "/tables",
    // },
    // {
    //   title: "User Profile",
    //   htmlBefore: '<i class="material-icons">person</i>',
    //   to: "/user-profile-lite",
    // },
    // {
    //   title: "Errors",
    //   htmlBefore: '<i class="material-icons">error</i>',
    //   to: "/errors",
    // }
  ];
   
  return menuItems.filter(item => item.roles.includes(role));
}
